import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import Instances from "@/pages/Instances";
import Campaigns from "@/pages/Campaigns";
import Inbox from "@/pages/Inbox";
import Lists from "@/pages/Lists";
import CampaignBuilder from "@/pages/CampaignBuilder";
import CampaignMonitor from "@/pages/CampaignMonitor";
import Admins from "@/pages/Admins";
import { Loader2 } from "lucide-react";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Loader2 className="h-5 w-5 animate-spin text-emerald-500" />
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
      <Route path="/listes" element={<Protected><Lists /></Protected>} />
      <Route path="/reponses" element={<Protected><Inbox /></Protected>} />
      <Route path="/instances" element={<Protected><Instances /></Protected>} />
      <Route path="/campagnes" element={<Protected><Campaigns /></Protected>} />
      <Route path="/campagnes/nouvelle" element={<Protected><CampaignBuilder /></Protected>} />
      <Route path="/campagnes/:id/modifier" element={<Protected><CampaignBuilder /></Protected>} />
      <Route path="/campagnes/:id" element={<Protected><CampaignMonitor /></Protected>} />
      <Route path="/admins" element={<Protected><Admins /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
